import { useBackend } from "../../services";
import { useEffect, useState } from "react";
import { StatusCodesHelper } from "../../models/StatusCodesHelper";
import { toast } from "react-toastify";
import { DataStorage } from "../../models/DataStorage";

export const useGetMediaGrades = <T>(
  setLoading: (loading: boolean) => void,
  dependencies: T[] = []
) => {
  const { get } = useBackend();
  const storage = DataStorage.mediaGradeStorage;
  const [mediaGrades, setMediaGrades] = useState(storage.getData(false, ""));
  useEffect(() => {
    if (mediaGrades && mediaGrades.length > 0) return;
    setLoading(true);
    get("mediaGrades").then(({ body, status }) => {
      if (StatusCodesHelper.isSuccessful(status)) {
        setMediaGrades(body);
        storage.setData(body, false, "");
      } else if (!StatusCodesHelper.isSessionExpired(status)) {
        toast.error(body.message);
      }
      setLoading(false);
    });
  }, dependencies);
  return mediaGrades;
};
